export const LabelTranslations = {
    PRODUCT_NAME: { en: "Product Name", he: "שם המוצר" },
    ברקוד: { en: "Barcode", he: "ברקוד" },
    SUPPLIER_NAME: { en: "Supplier Name", he: "שם הספק" },
    FACE: { en: "Face", he: "פנים" },
    LAYERS: { en: "Layers", he: "שכבות" },
    INTERNAL_CODE: { en: "Internal Code", he: "קוד פנימי" },
    LOCATION_ID: { en: "Location ID", he: "מיקום" },
    WIDTH: { en: "Width", he: "רוחב" },
    SALE: { en: "Sale", he: "מכירה" },
    LABEL: { en: "Label", he: "תווית" },
};

Object.freeze(LabelTranslations);